<script lang="ts">
	import type { MouseEventHandler } from "svelte/elements";
	import { iconMap } from "@core/assets/icons/iconMap.js";
	import type { ColoredIcon } from "@core/schema/ColoredIcon.js";
	import Button from "./common/Button.svelte";
	import { ButtonSize } from "./common/ButtonSize.js";
	import { ButtonVariant } from "./common/ButtonVariant.js";
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";

	const {
		active,
		onclick,
		icon,
		label,
	}: {
		active: boolean;
		onclick: MouseEventHandler<HTMLButtonElement>;
		icon: string | ColoredIcon | undefined;
		label: string;
	} = $props();
</script>

<Button
	variant={ButtonVariant.Subcategory}
	size={ButtonSize.Custom}
	class={[
		active && "outline outline-2 outline-fcrdarkgray",
		"h-12 sm:h-14 lg:h-16 xl:h-18 px-3 sm:px-4 md:px-5 lg:px-6",
	]}
	{onclick}
>
	<span class="flex items-center justify-between gap-4 sm:gap-8 lg:gap-12 2xl:gap-16 w-full">
		<span><Formatted text={label} /></span>
		{#if typeof icon === "string"}
			<Icon {icon} class="size-6 text-fcrdarkbrown" />
		{:else if typeof icon === "object"}
			{@const resolvedIcon = iconMap[icon.key]}
			{#if resolvedIcon}
				<Icon icon={resolvedIcon} style="color: {icon.color};" class="size-6" />
			{/if}
		{/if}
	</span>
</Button>
